module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-4-8d973a701d476f4623aa29c0b04e7e3a.svg";